import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";

const advancedSearchPageStorageProvider = createModuleStorage(localStorage, "si:pages:advanced-search");

export default advancedSearchPageStorageProvider;
